import { companyApi } from "./companyApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Company, CreateCompany, UpdateCompany } from "./company.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";


export const fetchCompanies = createAsyncThunk<
  APIResponse<Company[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'company/fetchCompanies',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        companyApi.endpoints.getCompanies.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Empresas',
          details: data.details
        });
    }
  }
);


export const fetchCompanyById = createAsyncThunk<APIResponse<Company>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'company/fetchCompanyById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        companyApi.endpoints.getCompanyById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Empresa por ID',
        details: data.details
      });
    }
  }
);


export const createCompany = createAsyncThunk<APIResponse<Company>, CreateCompany,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'company/createCompany',
  async (data: CreateCompany, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        companyApi.endpoints.createCompany.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Empresa',
        details: data.details
      });
    }
  }
);



export const updateCompany = createAsyncThunk<
  APIResponse<Company>,
   { id: number; changes: UpdateCompany }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'company/updateCompany',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        companyApi.endpoints.updateCompany.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Empresa',
        details: data.details
      });
    }
  }
);